var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOffHook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#79D191"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9887 41.1008C32.9887 41.1008 18.6663 36.8433 14.4055 22.5176",
    stroke: "#131951",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.001 39.1141C30.4009 36.3157 33.7698 35.1134 36.5241 36.4231C39.2784 37.7327 40.7075 40.3216 39.3076 43.1199C39.3076 43.1199 36.5474 42.3808 33.7413 41.3856C30.9352 40.3903 29.001 39.1141 29.001 39.1141V39.1141Z",
    stroke: "#131951",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3923 26.5053C19.1906 25.1054 20.393 21.7365 19.0833 18.9822C17.7737 16.2279 15.1848 14.7988 12.3865 16.1987C12.3865 16.1987 13.1256 18.959 14.1208 21.765C15.116 24.5711 16.3923 26.5053 16.3923 26.5053V26.5053Z",
    stroke: "#131951",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9754 20.2335C31.2525 19.6265 37.0814 24.3025 37.4615 29.4484",
    stroke: "#131951",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6893 15.7234C33.3357 15.2468 40.9581 21.3616 41.7095 27.7736",
    stroke: "#131951",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffHook);
export default __webpack_public_path__ + "static/media/off-hook.8b326b3cfd601a88ad77da5d8e3688a6.svg";
export { ForwardRef as ReactComponent };